import { useQuery } from "@tanstack/react-query"
import { listProducts } from "sdk/commerce/products"

export const productsKeys = {
  all: ["commerce/products"],
  list: () => [...productsKeys.all]
}

export function useListProducts({ params, ...queryConfig } = {}) {
  return useQuery({
    queryKey: productsKeys.list(),
    queryFn: () => listProducts(),
    staleTime: 10000,
    ...queryConfig
  })
}
